import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import snackBarReducer from "./snackBarSlice"
import requestReducer from "./requestDataSlice";

import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import {persistStore, persistReducer} from 'redux-persist';
import {combineReducers} from 'redux';
import chatReducer from './chatSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['chat', 'user', 'requestData'], // Persist chat, user, and requestData reducers

};

const rootReducer = combineReducers({
  user: userReducer,
  snackBar: snackBarReducer,
  requestData: requestReducer,
  chat: chatReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
